// Shipping Calculator Toggle

document.addEventListener('DOMContentLoaded', function () {
   const container = document.querySelector('.shipping-calculator-container');
   const toggles = document.querySelectorAll('.shipping-calculator-toggle');
   const form = document.querySelector('.shipping-calculator-form');
   const button = document.querySelector('.shipping-calculator-button');

   toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
         if (container) container.classList.toggle('pr-7');
         if (container) container.classList.toggle('w-fit');
         if (container) container.classList.toggle('w-full');
         if (form) form.classList.toggle('hidden');
         if (button) button.classList.toggle('hidden');
      });
   });
});

/**
 * Cart Shipping Calculator
 * ------------------------
 * Works with snippets/cart-shipping-calculator.liquid
 *
 * Flow:
 *  1. POST /cart/prepare_shipping_rates.json  -> starts rate calculation
 *  2. GET  /cart/async_shipping_rates.json    -> poll until rates are ready
 *
 * Save as: assets/cart-shipping-calculator.js
 */

(function () {
   'use strict';

   const COUNTRY_COOKIE = 'preferred_shipping_country';
   const ZIP_COOKIE = 'preferred_shipping_zip';
   const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

   // The shipping rate endpoints quote prices in the shop currency regardless
   // of the shopper's presentment currency, so amounts in this currency have
   // to be converted before they can be shown.
   const SHOP_CURRENCY = 'EUR';

   function setCookie(name, value) {
     document.cookie =
       name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
   }

   function getCookie(name) {
     const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
     return match ? decodeURIComponent(match[1]) : null;
   }

   function init() {
     const root = document.querySelector('[data-shipping-calculator]');
     if (!root) return; // calculator not on this page
 
     const form = root.querySelector('[data-shipping-form]');
     const countrySelect = root.querySelector('[data-shipping-country]');
     const zipInput = root.querySelector('[data-shipping-zip]');
     const submitBtn = root.querySelector('[data-shipping-submit]');
     const statusEl = root.querySelector('[data-shipping-status]');
     const ratesList = root.querySelector('[data-shipping-rates]');
 
     if (!form || !countrySelect || !submitBtn || !statusEl || !ratesList) {
       console.warn('[shipping-calculator] Missing required elements.');
       return;
     }
 
    // Locale-aware root (e.g. "/" or "/en-ca/") so it works on
    // multi-language stores. Falls back to "/".
    const localeRoot = root.dataset.localeRoot || '/';

   let isCalculating = false;

     // Restore the previously chosen country / zip from cookies.
     const savedCountry = getCookie(COUNTRY_COOKIE);
     if (savedCountry) {
       countrySelect.value = savedCountry;
     }
     const savedZip = getCookie(ZIP_COOKIE);
     if (savedZip && zipInput) {
       zipInput.value = savedZip;
     }
 
     // Listen on the button click instead of a form submit — the markup is
     // intentionally not a <form> so it can live inside the theme's cart form
     // without triggering a page-refreshing submit.
     submitBtn.addEventListener('click', calculate);
 
    // Nice-to-have: pressing Enter in the select also calculates
    countrySelect.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // don't submit a surrounding cart form
        calculate();
      }
    });

    // Re-calculate rates when the cart changes (quantity/remove/add) so the
    // displayed estimate stays in sync — but only if rates are already shown.
    // Debounced so the multiple update signals for a single cart change (the
    // `cart:updated` event and CartManager's direct call) collapse into one.
    let refreshTimer = null;
    function refreshRatesIfShown() {
      if (ratesList.hidden || !countrySelect.value) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(calculate, 400);
    }

    // Called directly by CartManager on cart-page quantity/remove changes,
    // which update the DOM without dispatching `cart:updated`.
    window.refreshShippingRates = refreshRatesIfShown;
    // Covers add-to-cart / notification updates fired across the site.
    document.addEventListener('cart:updated', refreshRatesIfShown);

  async function calculate() {

      if (isCalculating) return; // ignore double clicks
 
       const country = countrySelect.value;
       if (!country) {
         showStatus('Please select a country first.');
         clearRates();
         return;
       }
 
       isCalculating = true;
       setLoading(true);
       showStatus('Calculating shipping rates\u2026');
       clearRates();
 
       const paramsObj = {
         'shipping_address[country]': country,
       };
       const zip = zipInput ? zipInput.value.trim() : '';
       if (zip) {
         paramsObj['shipping_address[zip]'] = zip;
       }
       const params = new URLSearchParams(paramsObj).toString();

       // Persist the chosen location so it's prefilled next time.
       setCookie(COUNTRY_COOKIE, country);
       setCookie(ZIP_COOKIE, zip);
 
       try {
         // Step 1: ask Shopify to start calculating rates for this cart
         const prepareRes = await fetch(
           localeRoot.replace(/\/$/, '') + '/cart/prepare_shipping_rates.json?' + params,
           { method: 'POST' }
         );
 
         if (!prepareRes.ok) {
           // Shopify returns a JSON body explaining the problem, e.g.
           // 422 {"zip": ["can't be blank"]} or {"error": "..."} —
           // surface that instead of a generic failure.
           const message = await extractErrorMessage(prepareRes);
           showStatus(message);
           return;
         }
 
        // Step 2: poll until the rates are ready
        const rates = await pollRates(params);

        if (!rates || rates.length === 0) {
          showStatus('No shipping rates are available for this country.');
          return;
        }

        const shownCount = renderRates(rates);
        showStatus(
          shownCount === 1
            ? 'Shipping rate for ' + country + ':'
            : shownCount + ' shipping options for ' + country + ':'
        );
       } catch (err) {
         console.error('[shipping-calculator]', err);
         showStatus('Sorry, we could not calculate shipping. Please try again.');
       } finally {
         isCalculating = false;
         setLoading(false);
       }
     }
 
     /**
      * Polls async_shipping_rates.json until Shopify has rates ready.
      * Returns the shipping_rates array, or null after ~10 seconds.
      */
     async function pollRates(params, attempt = 0) {
       const MAX_ATTEMPTS = 20; // 20 x 500ms = 10s cap
       if (attempt >= MAX_ATTEMPTS) return null;
 
       const res = await fetch(
         localeRoot.replace(/\/$/, '') + '/cart/async_shipping_rates.json?' + params
       );
 
       if (!res.ok) {
         throw new Error('async_shipping_rates failed: ' + res.status);
       }
 
       // Shopify returns literal `null` while rates are still calculating
       const text = await res.text();
       if (!text || text === 'null') {
         await delay(500);
         return pollRates(params, attempt + 1);
       }
 
       const data = JSON.parse(text);
       if (!data || !data.shipping_rates) {
         await delay(500);
         return pollRates(params, attempt + 1);
       }
 
       return data.shipping_rates;
     }
 
    /** Renders each rate as a row: name .... price. Returns the number of rows shown. */
    function renderRates(rates) {
      ratesList.innerHTML = '';

      // When the cart contains recurring (subscription / selling plan) items,
      // Shopify returns a duplicate rate for the recurring shipment — identical
      // to the current shipment's rate in every field except price. There's no
      // flag distinguishing them, so collapse duplicates by rate identity and
      // keep only the first (current shipment) row to hide the recurring one.
      const seen = new Set();
      const uniqueRates = rates.filter(function (rate) {
        const key = [rate.name, rate.code, rate.description, rate.source].join('|');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // Cheapest first
      const sorted = uniqueRates
        .slice()
        .sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

      sorted.forEach(function (rate) {
         const li = document.createElement('li');
         li.className = 'shipping-rate-row flex justify-between';
 
         const name = document.createElement('span');
         name.textContent = rate.presentment_name || rate.name;
 
         const price = document.createElement('span');
         price.className = 'rate-price';
         price.textContent = formatMoney(rate.price, rate.currency);
 
         li.appendChild(name);
         li.appendChild(price);
         ratesList.appendChild(li);
       });
 
       ratesList.hidden = false;
       return sorted.length;
     }
 
    /**
     * Formats a rate price, which the Ajax API returns as a decimal string
     * (e.g. "10.00"). Shop-currency amounts are converted to the presentment
     * currency first; the result is an estimate, since checkout applies the
     * market's own conversion rounding.
     *
     * @param {string} price - Rate price as returned by the API.
     * @param {string} [quotedCurrency] - Currency the rate is quoted in.
     */
    function formatMoney(price, quotedCurrency) {
      const amount = parseFloat(price);
      if (isNaN(amount)) return price;

      const utils = window.CurrencyUtils;
      if (!utils) return amount.toFixed(2);

      const cents = Math.round(amount * 100);
      const active = utils.getCurrency();
      const quoted = quotedCurrency || SHOP_CURRENCY;

      if (quoted === active) {
        return utils.formatMoney(cents, active);
      }
      if (quoted === SHOP_CURRENCY) {
        return utils.formatMoney(utils.convertFromEUR(cents), active);
      }
      // Quoted in a third currency, so the shop's exchange rate doesn't apply —
      // label it with the currency it's actually in rather than mislabelling it.
      return utils.formatMoney(cents, quoted);
    }
 
     /**
      * Turns Shopify's error responses into a readable message.
      * 422 bodies look like: {"zip": ["can't be blank"]},
      * {"error": "..."} or {"shipping_address": {...}}.
      */
     async function extractErrorMessage(response) {
       const fallback =
         'Could not calculate shipping (' + response.status + '). Please check your input.';
       try {
         const body = await response.json();
         console.warn('[shipping-calculator] Shopify error body:', body);
 
         if (typeof body === 'string') return body;
         if (body.error) return body.error;
         if (body.description) return body.description;
 
         // Field errors: {"zip": ["can't be blank"], ...}
         const parts = [];
         Object.keys(body).forEach(function (field) {
           const value = body[field];
           const messages = Array.isArray(value) ? value.join(', ') : String(value);
           parts.push(field.replace(/_/g, ' ') + ' ' + messages);
         });
         return parts.length ? 'Please fix: ' + parts.join('; ') : fallback;
       } catch (e) {
         return fallback;
       }
     }
 
     function showStatus(message) {
       statusEl.textContent = message;
       statusEl.hidden = false;
     }
 
     function clearRates() {
       ratesList.innerHTML = '';
       ratesList.hidden = true;
     }
 
     function setLoading(loading) {
       if (submitBtn) submitBtn.disabled = loading;
     }
 
     function delay(ms) {
       return new Promise(function (resolve) {
         setTimeout(resolve, ms);
       });
     }
   }
 
   // Fixes the earlier "Cannot set properties of null" error:
   // wait for the DOM before querying elements.
   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', init);
   } else {
     init();
   }
 })();
 